<template>
  <v-card d-flex class="rounded-card" style="min-height: 40vh; overflow: hidden">
    <v-btn
      absolute
      right
      class="mt-2"
      color="blue"
      fab
      id="close-button"
      @click="$emit('onClose')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-row style="min-height: 43vh">
      <v-col cols="12" lg="6" class="background-grey">
        <v-card
          class="mx-2"
          color="#E3E3E3"
          width="100%"
          flat
          rounded>
          <v-img class="ml-2" src="@/assets/images/BBVA.png" alt="BBVA" width="200px"/>
          <v-card-text class="mt-4">
            <table>
              <tbody class="primary--text">
                <tr>
                  <th class="text-right px-2 font-weight-black">Concepto:</th>
                  <td>BLÚ USD</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Monto:</th>
                  <td>{{ totalInvoicesUSD | currency }}</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Referencia:</th>
                  <td>{{paymentReference}}</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Banco:</th>
                  <td>BBVA MÉXICO, S.A., INSTITUCIÓN DE BANCA MÚLTIPLE, GRUPO FINANCIERO BBVA MÉXICO</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Moneda:</th>
                  <td>USD</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Cuentahabiente:</th>
                  <td>AGRONEGOCIOS DE CHIHUAHUA S.A. DE C.V. SOFOM ENR</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">RFC:</th>
                  <td>ACI-121115-GMA</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Cuenta:</th>
                  <td>0123019756</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Clabe:</th>
                  <td>012 15000 1230197565</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card
          class="mx-2"
          width="100%"
          flat
          rounded>
          <v-img class="ml-2" src="@/assets/images/BBVA.png" alt="BBVA" width="200px"/>
          <v-card-text class="mt-4">
            <table>
              <tbody class="primary--text">
                <tr>
                  <th class="text-right px-2 font-weight-black">Concepto:</th>
                  <td>BLÚ MXN</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Monto:</th>
                  <td>{{ totalInvoicesMXN | currency }}</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Referencia:</th>
                  <td>{{paymentReference}}</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Banco:</th>
                  <td>BBVA MÉXICO, S.A., INSTITUCIÓN DE BANCA MÚLTIPLE, GRUPO FINANCIERO BBVA MÉXICO</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Moneda:</th>
                  <td>MXN</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Cuentahabiente:</th>
                  <td>AGRONEGOCIOS DE CHIHUAHUA S.A. DE C.V. SOFOM ENR</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">RFC:</th>
                  <td>ACI-121115-GMA</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Cuenta:</th>
                  <td>0100227862</td>
                </tr>
                <tr>
                  <th class="text-right px-2 font-weight-black">Clabe:</th>
                  <td>012 15000 1002278625</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-btn
        absolute
        bottom
        @click="createPDF(reference)"
        :fab="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
        :right="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
        color="primary"
        :class="{
          'download-reference-btn center-horizontal-btn': !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm,
          'mb-10': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
        }"
      >
        <v-icon :class="{ 'mr-2': !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm }">mdi-printer-settings</v-icon>
        <span v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" class="font-weight-black">
          Descargar referencia
        </span>
      </v-btn>
    </v-row>
  </v-card>
</template>

<script>
import ClientService from '@/services/ClientService'
import FactoringDocumentService from '@/services/FactoringDocumentService'
import GenericService from '@/services/GenericService'
import Util from '@/common/utils.js'
import moment from 'moment-timezone'

export default {
  name: 'PaymentReference',
  props: {
    paymentReference: String,
    referenceId: Number
  },
  data () {
    return {
      reference: null,
      selected: {},
      invoices: [],
      totalInvoicesMXN: 0,
      invoicesMXN: 0,
      totalInvoicesUSD: 0,
      invoicesUSD: 0
    }
  },
  async mounted () {
    await this.loadRecord()
  },
  methods: {
    async loadRecord () {
      const loader = this.$loading.show()
      this.loading = true
      try {
        const invoices = await FactoringDocumentService.getDocuments({
          clientId: this.$store.getters.user.client.clientId,
          paymentReference: this.paymentReference
        })
        this.invoices = invoices.data.map(item => item)
        this.invoicesMXN = this.invoices
          .filter(invoice => invoice.currency === 'MXN')
        this.totalInvoicesMXN = this.invoicesMXN
          .map(item => item.total).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
        this.invoicesUSD = this.invoices
          .filter(invoice => invoice.currency === 'USD')
        this.totalInvoicesUSD = this.invoicesUSD
          .map(item => item.total).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)

        var { paymentReference } = await ClientService.getPaymentReferenceByID({ referenceId: this.referenceId, rfc: this.$store.getters.user.client.rfc })

        if (paymentReference) {
          this.reference = paymentReference
        } else {
          throw new Error('PAYMENT_REFERENCE_RECORD_NOT_FOUND')
        }
        loader.hide()
        this.loading = false
      } catch (error) {
        /*
          ToDo: [✔]
            [☢] SWAL para mostrar error en caso de no poder obtener el registro y pedir al cliente que consulte luego en historial
        */
        loader.hide()
        console.error(error)
      }
    },

    async createPDF (record) {
      const loader = this.$loading.show()

      try {
        const data = await GenericService.downloadFile(`/client/payment-reference/${record.id}/base64`)
        const blob = Util.converBase64toBlob(data.base64, 'application/pdf')
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${record.reference}`
        loader.hide()
        link.click()
      } catch (error) {
        this.$swal('¡Error!', 'No se pudo generar el documento, contacta al administrador', 'error')
      }
    }
  },
  filters: {
    date (date) {
      return moment(date).local().format('DD-MMM-YYYY h:mm a')
    }
  }
}
</script>

<style scoped>
  .background-grey {
    background-color: #E3E3E3;
  }
  table {
    font-size: 15px!important;
  }
  #close-button {
    background-color: #0420BF !important;
    color: white;
  }
  .download-reference-btn {
    background-color: #0420BF !important;
    color: white;
    border-radius: 20px !important;
  }
  .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
      background: #ebf1f8!important;
  }
  .center-horizontal-btn {
    left: 50%;
    transform: translateX(-50%);
  }
  .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
    background: #ebf1f8!important;
  }
</style>
